export enum Environment {
	PROD = "PROD",
	QA = "QA",
}

const determineEnvironment = (hostname: string, prodHostName: string): Environment => {
	if (hostname === prodHostName) {
		console.log("getCurrentEnvironment.determineEnvironment: Detected PROD environment");
		return Environment.PROD;
	}

	console.log("getCurrentEnvironment.determineEnvironment: Defaulting to QA environment");
	return Environment.QA;
};

export const getCurrentEnvironment = (): Environment => {
	const hostname = window.location.hostname.toLowerCase();
	const prodURL = process.env.PUBLIC_URL;

	if (!prodURL) {
		console.log("getCurrentEnvironment: No PUBLIC_URL found in .env, defaulting to QA environment");
		return Environment.QA;
	}

	try {
		const prodHostName = new URL(prodURL).hostname.toLowerCase();
		return determineEnvironment(hostname, prodHostName);
	} catch (error) {
		console.warn("getCurrentEnvironment: Failed to parse PUBLIC_URL", { prodURL, error });
		console.log("getCurrentEnvironment: Defaulting to QA environment");
		return Environment.QA;
	}
};
